<template>
  <div class="first-step-component">
    <food-window
      v-if="showFoodWindow"
      @close="closeFoodWindow"
      :item="currentFoodItem"
    />
    <promotions-window v-if="showPromotionsWindow" />

    <section v-show="!showFoodWindow && !showPromotionsWindow">
      <food-categories />
      <v-row v-if="menuItems.length" class="menu-items">
        <v-loader v-show="isLoading" absolute />
        <v-col v-for="(item, i) in menuItems" :key="i" sm="3">
          <food-card
            :item="item"
            @openFoodWindow="openFoodWindow"
            new
            bonus
            child
          />
        </v-col>
      </v-row>
      <span v-else class="d-block display-3 text-center">Ничего не найдено</span>
    </section>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import VLoader from '@/components/loader/Loader'
  import FoodCategories from './food-categories/FoodCategories'
  import FoodCard from './food-card/FoodCard'
  import FoodWindow from './food-window/FoodWindow'
  import PromotionsWindow from './promotions-window/PromotionsWindow'

  export default {
    name: 'FirstStep',
    components: {
      VLoader,
      FoodCategories,
      FoodCard,
      FoodWindow,
      PromotionsWindow,
    },
    computed: {
      ...mapState({
        showPromotionsWindow: (state) => state.newOrder.showPromotionsWindow,
        isLoading: (state) => state.newOrder.isMenuItemsLoading,
        menuItems: (state) => state.newOrder.menuItemsList || [],
      }),
    },
    data () {
      return {
        showFoodWindow: false,
        currentFoodItem: {},
      }
    },
    methods: {
      openFoodWindow (item) {
        this.currentFoodItem = item
        this.showFoodWindow = true
      },
      closeFoodWindow () {
        this.showFoodWindow = false
      },
    },
    mounted () {},
    beforeDestroy () {
      this.showFoodWindow = false
    },
  }
</script>

<style lang="less" scoped>
.first-step-component {
  background-color: transparent;

  .menu-items {
    position: relative;
    z-index: 0;
  }
}
</style>
